import React from "react";
import classes from "./TeacherComment.module.scss";

type Props = {
  image: string;
  comment?: string[];
  children?: React.ReactNode;
  bgWhite?: boolean;
  charLeft?: boolean;
  charRight?: boolean;
};

const TeacherComment = (props: Props) => {
  const imageElement = (
    <img className={classes.icon} src={props.image} alt={props.image} />
  );

  const commentElement = (
      <div
        className={`${classes.comment} ${props.bgWhite ? classes.white : ""} ${
          props.charRight ? classes.right : ""
        }`}
      >
      {props.comment?.map((c, index) => (
        <div key={`teacher-comment-${index}`}>{c}</div>
      ))}
      {props.children != null && <>{props.children}</>}
    </div>
  );

  return (
    <div className={classes.container}>
      {props.charRight ? (
        <>
          {commentElement}
          {imageElement}
        </>
      ) : (
        <>
          {imageElement}
          {commentElement}
        </>
      )}
    </div>
  );
};

export default TeacherComment;
